export const PLAYED_MOVE_ARROW_COLOR = "#f9c267";
export const PLAYED_MOVE_SQUARE_TINT = "rgba(249,194,103,0.34)";
